import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "../assets/css/Zoomstyle.css";

const Zoomimage = ({ showModal, handleCloseModal, modalImage }) => {
  const [zoomStyle, setZoomStyle] = useState({});
  const [isZoomed, setIsZoomed] = useState(false);
  const updateZoom = (clientX, clientY, container) => {
    const rect = container.getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    setZoomStyle({
      transform: "scale(2)",
      transformOrigin: `${xPercent}% ${yPercent}%`,
      transition: "transform 0.1s ease",
    });
  };

  // Desktop
  const handleMouseMove = (e) => {
    updateZoom(e.clientX, e.clientY, e.currentTarget);
  };

  const handleMouseEnter = () => {
    if (window.innerWidth > 992) {
      setIsZoomed(true);
    }
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setZoomStyle({});
  };

  // Mobile & Tablet
  const handleTouchStart = (e) => {
    setIsZoomed(true);
    const touch = e.touches[0];
    updateZoom(touch.clientX, touch.clientY, e.currentTarget);
  };

  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    updateZoom(touch.clientX, touch.clientY, e.currentTarget);
  };

  const handleTouchEnd = () => {
    setIsZoomed(false);
    setZoomStyle({});
  };

  return (
    <Modal show={showModal} onHide={handleCloseModal} fullscreen centered={false} backdrop="static" className="zoom-modal">
      <Modal.Header className="p-0 border-0 d-flex justify-content-end">
        <button
          onClick={handleCloseModal}
          aria-label="Close"
          style={{
            border: "1px solid #928d8d",
            background: "#fff",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            color: "#f00",
            cursor: "pointer",
          }}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </Modal.Header>

      <Modal.Body className="text-center">
        <div
          className="zoom-container"
          onMouseEnter={handleMouseEnter}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <img
            src={modalImage}
            alt="Zoom"
            className={`zoom-image ${isZoomed ? "zoomed" : ""}`}
            style={zoomStyle}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Zoomimage;